import { useAccountsStore } from '../stores/useAccountsStore'
import { useCurrenciesStore } from '../stores/useCurrenciesStore'
import { useTariffsStore } from '../stores/useTariffsStore'
import { useAddressesStore } from '../stores/useAddressesStore'
import { useConverterStore } from '../stores/useConverterStore'
import { usePaymentsDeps } from '../useDeps'
import type { RawCurrency } from '../interfaces'

export default defineNuxtPlugin({
  name: 'paymentStoresInit',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore payments have no idea about site plugins
  dependsOn: ['paymentsDeps', 'init-plugin'],
  async setup() {
    const { isAuthenticated } = usePaymentsDeps()

    const { $init } = useNuxtApp()
    const { getCurrenciesAndNetworks, setCurrencies } = useCurrenciesStore()
    const { fetchCurrencyRates } = useConverterStore()
    const { getAccountList, resetAccounts } = useAccountsStore()
    const { getAddresses } = useAddressesStore()
    const { getTariffs } = useTariffsStore()

    setCurrencies(($init?.currencies as RawCurrency[]) ?? [])

    watchEffect(async () => {
      if (isAuthenticated.value) {
        await getCurrenciesAndNetworks()
        await fetchCurrencyRates()
        await getAccountList()
        getAddresses()
        getTariffs()
      } else {
        resetAccounts()
      }
    })
  },
})
